import { Link } from '@/marketing/link';
import { SHIFT_AI_URL } from '@/lib/links';

export function Footer() {
  return (
    <footer className="bg-foreground text-background py-24 border-t border-border">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 mb-24">
          <div>
            <div className="flex items-center gap-2 mb-8">
              <span className="font-sans font-bold text-3xl tracking-tighter text-background">AI Boost</span>
              <span className="mono-micro text-background/50 border border-background/20 px-1.5 py-0.5 ml-2">BY SHIFT</span>
            </div>
            <p className="text-lg text-background/80 font-medium max-w-sm">
              AI Boost is SHIFT AI’s measurement platform for seeing how AI changes work, month by month.
            </p>
            <a
              href={SHIFT_AI_URL}
              className="inline-flex mt-6 font-mono text-sm uppercase tracking-widest text-background/60 hover:text-primary transition-colors"
            >
              Visit SHIFT AI
            </a>
          </div>
          <div className="grid grid-cols-2 gap-8 font-mono text-sm uppercase tracking-widest text-background/60">
            <div className="flex flex-col gap-4">
              <Link href="/engine" className="hover:text-primary transition-colors">The Engine</Link>
              <Link href="/ceos" className="hover:text-primary transition-colors">For leaders</Link>
            </div>
            <div className="flex flex-col gap-4">
              <Link href="/pricing" className="hover:text-primary transition-colors">Plans</Link>
              <Link href="/faq" className="hover:text-primary transition-colors">FAQ</Link>
              <Link href="/login" className="hover:text-primary transition-colors">Log in</Link>
            </div>
          </div>
        </div>
        
        <div className="border-t border-background/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm font-medium text-background/60">
            The covenant: Your hours are never used against you.
          </p>
          <div className="mono-micro text-background/40">
            © {new Date().getFullYear()} SHIFT.
          </div>
        </div>
      </div>
    </footer>
  );
}
